<div class="persona-choice" (click)="onChosen()" *ngIf="ready">
  <se-po-persona-avatar
    headerDataSize="600"
    [persona]="profile.persona">
    <se-fe-button
      personaAvatarActions
      (click)="onEdit($event); false"
      seFeDataEmphasis="low">
      {{ 'SE_PO_UI_PERSONA_CHOICE.EDIT' | translate }}
    </se-fe-button>
  </se-po-persona-avatar>
</div>
